import React, { useRef,useEffect,useState } from 'react'
 import { useStore } from './store'
import AppConfig from './Config.js';
import { useSpring, animated,useTrail } from 'react-spring';
import { Light } from 'three';
import { Howl, Howler } from 'howler';
import ReactHowler from 'react-howler';
import {useNavigate ,useLocation } from 'react-router-dom';
import './style.css';
const hostloca=AppConfig.cdnUrl;

let ballarray= create2DArray(8, 8, false);

let bgsound=false
let usehowler=false

let userscoretype='a'

let setdata=false
let cardgroup=[0,3,4,5,8,10,11,15,20,22]
let game_state=1

let showcollect=false
let showedtips=0
let showtipscount=[0,0,0]
let ontips=false
let soundstate='on'

function create2DArray(rows, cols, defaultValue) {
    return Array.from({ length: rows }, () => Array.from({ length: cols }, () => defaultValue));
  }


function DotMatrix(props) {
    const [matrix, setMatrix] = useState(ballarray);


   

    let ballsize=20
    let sw=window.innerWidth
    let sh=window.innerHeight
    let ballspace=sw/9
    let startx= (sw-(ballspace*7)-ballsize)/2 
    let starty=(sh-(ballspace*7)-ballsize)/2 -sh/32
    
    
  
    const triggerAnimation = (row, col) => {
      const newMatrix = matrix.map((rowArray, rowIndex) => 
        rowIndex === row ? rowArray.map((item, colIndex) => colIndex === col ? true : item) : rowArray
      );
      setMatrix(newMatrix);


    };

      useEffect(() => {
            
              let mk=props.mark
            if(mk.length>0){

             
                let resetcubegroup= create2DArray(8, 8, false); //reset ball
               for(let j=0;j<props.mark.length;j++){
                   resetcubegroup[mk[j][0]][mk[j][1]]=true
                 }
      
                ballarray=resetcubegroup
                setMatrix(resetcubegroup);
                
            }

          
        
        },[props])


    useEffect(() => {

      //  console.log(matrix)


        },[matrix])

    
  
    const calculateXMove = (colIndex,rowIndex) => {
      const startPos = colIndex * ballspace+startx+(colIndex-6)*5; // 每个点的起始X位置
      const endPos = sw/2; // 中心线位置
      return `${endPos - startPos}px`; // 计算需要移动的距离
    };

    const calculateYMove = (colIndex,rowIndex) => {
        const startPos = rowIndex * ballspace+starty; // 每个点的起始X位置
        const endPos = sh*.94-(rowIndex * ballspace)/10; // 中心线位置
        return `${endPos - startPos}px`; // 计算需要移动的距离
      };
  
    return (
      <div style={{ position: 'absolute', width: '100VW', height: '92vh', margin: 'auto',display:'flex',alignContent:'center',justifyContent:'center',pointerEvents:'none',overflow:'hidden',left:0,top:0 }}>
        {matrix.map((row, rowIndex) =>
          row.map((isActive, colIndex) => (
            <div
              key={`${rowIndex}-${colIndex}`}
              className="dot"
              style={{
                left: `${colIndex * ballspace+startx}px`,
                top: `${rowIndex * ballspace+starty}px`,
                animation: isActive ? `moveToCenter ${1.5-rowIndex/12}s ease-out` : 'none',
                '--x-move': isActive ? calculateXMove(colIndex,rowIndex) : '0px', // 设置变量控制X轴移动
                '--y-move': isActive ? calculateYMove(colIndex,rowIndex) : '0px' // 设置变量控制X轴移动
              }}
              //onClick={() => triggerAnimation(rowIndex, colIndex)}
            />
          ))
        )}
      </div>
    );
  }
  
  

  const Confetti = (props) => {
    const [flloweralpha,setflloweralpha]=useState(1)
 
  //  const colors=['#B833EA','#CCE7AD','#EFEEEF','#D7D7D7','#CCE7AD','99B3F6','#EFEEEF','#CCE7AD']

    const colors=['#ffffff','#333','#ffffff','#999','#ffffff','ffffff','#ffffff','#999']


    useEffect(()=>{

          if(props.scoretype=='c'){

            setflloweralpha(0)
          }else{

            setflloweralpha(1)
          }

    },[props])
 
  const boxes = Array.from({ length: 50 }, (_, index) => {
    const angle = Math.random() * 2 * Math.PI;
    const radius = 150 + Math.random() * 150;
    return {
      id: index,
      xOffset: Math.cos(angle) * radius + 'px', // Calculate the horizontal offset
      yOffset: Math.sin(angle) * radius + 'px', // Calculate the vertical offset
      rotateX: Math.random() * 360 + 'deg',     // Random X-axis rotation
      rotateY: Math.random() * 360 + 'deg',     // Random Y-axis rotation
      rotateZ: Math.random() * 360 + 'deg',     // Random Z-axis rotation
      scale: Math.random() * 0.5 + 0.5, // 确保大小不会太小
      randColor: colors[Math.floor(Math.random() * 8)],
      delay: Math.random() * 3*.1 // 随机延迟，最多5秒
    };
  });

  return (
    <div style={{position:'absolute',width:'100vw',height:'100vh',opacity:flloweralpha}}>

      {boxes.map(box => (
        <div
          key={box.id}
          className="box"
          style={{
            '--x-offset': box.xOffset,
            '--y-offset': box.yOffset,
            '--rotate-x': box.rotateX,
            '--rotate-y': box.rotateY,
            '--rotate-z': box.rotateZ,
            '--randColor': box.randColor,
            '--scale': box.scale,
            animationDelay: `${box.delay}s, ${box.delay}s`
          }}
        />
      ))}


    </div>
  );
      
  };

function FlipCard({ show ,score,scorestate,targetnum}) {
    const [flipped, setFlipped] = useState(false);

    const [carda, setcarda] = useState(false);
    const [cardb, setcardb] = useState(false);
    const [cardc, setcardc] = useState(false);
    const [wpcollectcount, setwpcollectcount] = useState(0);

    const [cardurl, setcardurl] = useState('');

    const [wpnum, setwpnum] = useState('0');

    const scoretonumbrt=Number(score)

    const [wptumbshow,setwptumbshow]=useState([[0,1],[0,1],[0,1]])
    const [showwptumb,setshowwptumb]=useState('none')
    const [hidewptumb,sethidewptumb]=useState('none')
   
    let wplistarray=[0,0,0]
    let renewwptumb=[[0,1],[0,1],[0,1]]
     
    // 控制卡片的上升和透明度动画，响应 `show` 状态的改变
    const riseProps = useSpring({
      to: {
        opacity: show ? 1 : 0, // 终止状态：显示时透明度为 1，隐藏时透明度为 0
        marginTop: show ? '-20vh' : '-100vh' // 初始位置在屏幕60%高度处，终止位置为屏幕中心
      },
      from: {
        opacity: 0, // 开始状态：透明度从 0 开始
        marginTop: '-100vh' // 初始位置从屏幕的 60% 高度开始
      },
      config: { duration: 700 } // 控制动画运行速度，这里设为1000毫秒
    });
  
    // 控制卡片翻转动画，响应 `flipped` 状态的改变
    const { transform, opacity } = useSpring({
      opacity: flipped ? 1 : 0,
      transform: `perspective(1000px) rotateY(${flipped ? 180 : 0}deg)`,
      config: { mass: 5, tension: 500, friction: 80 }
    });


     useEffect(()=>{


     
      console.log(wpcollectcount+'///got wall paper count')

      },[wpcollectcount])





    useEffect(() => {
     
      if( setdata==false){
        setdata=true
      const storedName = localStorage.getItem('mm_user_nick');
      const mmusermarktype = localStorage.getItem('mm_user_marktype');
      const mmuserticket = localStorage.getItem('mm_user_ticket');

      const mmusertopscore = localStorage.getItem('mm_user_top_score');

      
                    // localStorage.removeItem('mm_user_top_score');
                    //统计壁纸已解锁数
                    let wpcount=0
        

                    if(mmusermarktype){
                    
                      const aparts = mmusermarktype.split('&');
                      const wplist = aparts[1].split('');
                      wplistarray=wplist

                    //设置壁纸状态
                    renewwptumb=[[0,1],[0,1],[0,1]]
                      for(let i=0;i<wplist.length;i++){

                        if(wplist[i]==1){
                          wpcount+=1
                          renewwptumb[i]=[1,0]
                          }
                      }
                    
                      setwptumbshow(renewwptumb)
                      setwpcollectcount(wpcount)
                      console.log('got wp state =========='+renewwptumb)

                  
                     
                    
                    }else{

                      alert('no local')
                    }  

      //查询目前最高分前20名=========================================================

       
      if(scorestate=='c'){
          //未完成通关
        setcardc(true)

      }else{


                const chechttopscore = async () => {
                          const postData = {
                            score: null, 
                            
                          };
              
                          try {
                            const response = await fetch('https://api.irabit.net/api/auth/WxcheckScoreMark_notk', {
                              method: 'POST',
                              headers: {
                                'Content-Type': 'application/json'
                              },
                              body: JSON.stringify(postData)
                            });
                      
                            if (!response.ok) {
                              return false
                              throw new Error(`HTTP error! status: ${response.status}`);
                            }
                            const result = await response.json();
                            if(result.status==true){
                              console.log('top 20 score:', result.data);
                              localStorage.setItem('mm_user_top_score', result.data);
                              
                               //=======================================================================================================================================
                                if(scoretonumbrt>Number(result.data)){
                                        if(!carda && !cardb)setcarda(true)  //score超过百分之20用户

                                        //壁纸判断
                                        let getwp=game_state-1   //get wallpaper
                                        if(getwp==0)getwp=3 //0的话后端接口无法识别
                                        Saveuserscore(getwp) //更新数据库

                                        if(wplistarray[game_state-1]==1){
                                             //已经领取过壁纸  
                                             sethidewptumb('flex')
                                             setshowwptumb('none')
                                           //  alert('Already got wp')
                                        }else{
                                              //没有领取过
                                             // alert('Get new wp')
                                              setwpcollectcount(wpcollectcount+1)
                                              let secrenewwptumb=Array.from(renewwptumb)
                                              secrenewwptumb[game_state-1]=[1,0]
                                              setwptumbshow(secrenewwptumb)
                                              console.log('update wp state ==========='+secrenewwptumb)
                                              setshowwptumb('flex')
                                              sethidewptumb('none')

        
                                              localStorage.setItem('mm_user_wp_notic', 1);

         

                                        }
                                   

                                  

                                }else{
                                            if(!carda && !cardb)setcardb(true)
                                            let getwp=null
                                            Saveuserscore(getwp)
                                           // alert('3')
                                            console.log('Score not up to 20% / update local')
                                }

                            }else{
                              return false
                              console.log('fail:', result);

                            }
                            
                            
                          } catch (error) {
                            return false
                            console.error('Error:', error);
                          }
             };




   //访问本地最高分==================================================================================================


                if (mmusertopscore) {
                    //先查询本地

                  //  localStorage.setItem('mm_user_top_score',20);//reset


                    if(scoretonumbrt>mmusertopscore){
                        chechttopscore()
                    }else{
                      if(carda==false && cardb==false)setcardb(true)  //未超过20%
                        let getwp=null
                        Saveuserscore(getwp)
                        console.log('Score not up to 20% '+ mmusertopscore )

                    }
                }else{
                      //无本地记录查询数据库
                     // alert('no local storage data')
                      chechttopscore()    
                }







                 




        //访问数据库
        //========================================================================

           function Saveuserscore(getwp){

                   


                    if (storedName && mmusermarktype && mmuserticket ) {
                     

                                  console.log('User : '+storedName)
                                  console.log('User type: '+mmusermarktype)
                                  console.log('User ticket: '+mmuserticket)

                                
                                  const targetindex = cardgroup.indexOf(targetnum);
                                  

                                  console.log(targetindex+'=========================================')


                                      


                                    const handleuserSubmit = async () => {
                                      const postData = {
                                        score: scoretonumbrt,
                                        ticket: mmuserticket,
                                        card:targetindex,
                                        wallpaper:getwp,
                                        game:game_state,
                                        
                                      };
                                  
                                      try {
                                        const response = await fetch('https://api.irabit.net/api/auth/WxUpdateScoreMark_notk', {
                                          method: 'POST',
                                          headers: {
                                            'Content-Type': 'application/json'
                                          },
                                          body: JSON.stringify(postData)
                                        });
                                  
                                        if (!response.ok) {
                                          throw new Error(`HTTP error! status: ${response.status}`);
                                        }
                                  
                                        const result = await response.json();
                                        
                                        if(result.status==true){
                                          
                                          console.log('update user Success:', result.data);
                                          
                                    
                                          localStorage.setItem('mm_user_marktype', result.data);

        

                                        }else{

                                          console.log('fail:', result);

                                        }
                                        
                                        
                                      } catch (error) {
                                        console.error('Error:', error);
                                      }
                                    };

                                    handleuserSubmit();


                          }else{


                                //注意判断=================================================================================
                                console.log('no user localStorage data===================')

                               // if(carda==false)setcardb(true)
                              //  alert('no localStorage data...')

                          }


            }


      }

        //=======================================================================================================================================================


     


        let imgurl=hostloca+'Assets/card'+targetnum+'.png'

        setcardurl(imgurl)



    }

  
      }, [scorestate]); // 依赖于 show
  
      
  
    // 设置自动翻转===============================================================================================
    useEffect(() => {
      let timer;
      if (show) {
        timer = setTimeout(() => {
         if(scorestate!='c')setFlipped(true);
        }, 4400); // 4秒后自动翻转
        return () => clearTimeout(timer);
      } else {
        setFlipped(false); // 重置翻转状态
      }


     

    }, [show]); // 依赖于 show
  
    return (
      <div style={{ width: '100%', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
        <animated.div style={{
          ...riseProps,
          width: '75vw',
          height: '300px',
          borderRadius: '0px',
          position: 'absolute',
          willChange: 'transform, opacity',
          backfaceVisibility: 'hidden',
          transform: transform.interpolate(t => `${t} rotateY(0deg)`),
          opacity: opacity.interpolate(o => 1 - o),
        }}>
                                     

                              {carda? (
                                  <div style={{width:'100%',height:'12vw',position:'absolute',top:'0vh',display:'flex',justifyContent:'center',alignItems:'center'}}>
                                    
                                            <div style={{display:showwptumb,position:'absolute',justifyContent:'center',alignItems:'center',width:'100%',top:'0vh'}}>
                                                      <div style={{position:'absolute',width:'100%',top:0}}>
                                                      <img  src={hostloca+'Assets/flipcarda.png'} style={{width:'100%'}}/> 
                                                      </div>

                                      
                                                                <span className='textcard' style={{fontSize:'3vw',letterSpacing:'.4vw',top:'5vh',paddingLeft:'0vw',position:'absolute',color:'white'}}>FINAL SCORE!</span>  
                                                                <span className='textscored' style={{fontSize:'10vw',letterSpacing:'.5vw',top:'6.6vh',fontWeight:'bold',paddingLeft:'0vw',position:'absolute',color:'white'}}>{scoretonumbrt} </span>  
                                                                <span className='textnormal' style={{fontSize:'2.8vw',letterSpacing:'.5vw',top:'15vh',paddingLeft:'0vw',position:'absolute',fontWeight:400,color:'white'}}>您成功超越80%的玩家</span>  
                                                                <span className='textcard' style={{fontSize:'7vw',letterSpacing:'.4vw',top:'20vh',paddingLeft:'0vw',position:'absolute',color:'white'}}>Excellent!</span>  
                                                                
                                                                            
                                                                            <img  src={hostloca+'Assets/cardline7.png'} style={{width:'60%',position:'absolute',top:'43vh'}}/> 


                                                                  
                                                                            <div style={{position:'absolute',top:'30vh',width:'100%',display:'flex',justifyContent:'center',alignItems:'center'}}>
                                                                                          <div style={{width:'60vw',height:'10vh',position:'absolute',top:'0vh',display:'flex',alignItems:'center',justifyContent:'center',}}>

                                                                                                        <div style={{width:'12vw',height:'10vh',display:'flex',alignItems:'center',justifyContent:'center'}}>
                                                                                                          <img className='breathing-effect' src={hostloca+'Assets/shine.png'} style={{width:'24vw',position:'absolute',opacity:wptumbshow[0][0]}}/> 
                                                                                                          <img  src={hostloca+'Assets/wptumb1.png'} style={{width:'12vw',position:'absolute',opacity:wptumbshow[0][0]}}/> 
                                                                                                          <img  src={hostloca+'Assets/wpnull.png'} style={{width:'10vw',position:'absolute',opacity:wptumbshow[0][1]}}/> 
                                                                                                                
                                                                                                        </div>
                                                                                                        <div style={{width:'12vw',height:'10vh',display:'flex',alignItems:'center',justifyContent:'center',marginLeft:'2vw',marginRight:'2vw'}}>
                                                                                                          <img className='breathing-effect' src={hostloca+'Assets/shine.png'} style={{width:'24vw',position:'absolute',opacity:wptumbshow[1][0]}}/> 
                                                                                                          <img  src={hostloca+'Assets/wptumb2.png'} style={{width:'12vw',position:'absolute',opacity:wptumbshow[1][0]}}/>    
                                                                                                          <img  src={hostloca+'Assets/wpnull.png'} style={{width:'10vw',position:'absolute',opacity:wptumbshow[1][1]}}/>     

                                                                                                        </div>
                                                                                                        <div style={{width:'12vw',height:'10vh',display:'flex',alignItems:'center',justifyContent:'center'}}>
                                                                                                          <img className='breathing-effect' src={hostloca+'Assets/shine.png'} style={{width:'24vw',position:'absolute',opacity:wptumbshow[2][0]}}/> 
                                                                                                          <img  src={hostloca+'Assets/wptumb3.png'} style={{width:'12vw',position:'absolute',opacity:wptumbshow[2][0]}}/>         
                                                                                                          <img  src={hostloca+'Assets/wpnull.png'} style={{width:'10vw',position:'absolute',opacity:wptumbshow[2][1]}}/>       
                                                                                                        </div>
                                                                                          </div>
                                                                              </div>
                                               </div>

                                           {/*-----------------------*/}


                                                      <div style={{display:hidewptumb,position:'absolute',justifyContent:'center',alignItems:'center',width:'100%',top:'0vh'}}>

                                                              <div style={{position:'absolute',width:'100%',top:0}}>
                                                              <img  src={hostloca+'Assets/flipcardbg3.png'} style={{width:'100%'}}/> 
                                                              </div>

                                                              
                                                                <span className='textcard' style={{fontSize:'3vw',letterSpacing:'.4vw',top:'6vh',paddingLeft:'0vw',position:'absolute',color:'white'}}>FINAL SCORE!</span>  
                                                                <span className='textscored' style={{fontSize:'10vw',letterSpacing:'.5vw',top:'7.6vh',fontWeight:'bold',paddingLeft:'0vw',position:'absolute',color:'white'}}>{scoretonumbrt} </span>  
                                                                <span className='textnormal' style={{fontSize:'2.8vw',letterSpacing:'.5vw',top:'18vh',paddingLeft:'0vw',position:'absolute',fontWeight:400,color:'white'}}>您成功超越80%的玩家</span>  
                                                                <span className='textcard' style={{fontSize:'7vw',letterSpacing:'.4vw',top:'25vh',paddingLeft:'0vw',position:'absolute',color:'white'}}>Excellent!</span>  

 
                                                           <img  src={hostloca+'Assets/cardline8.png'} style={{width:'90%',position:'absolute',top:'38vh'}}/> 
                                                      </div>
                                    </div>
                                ):('')}    
                                     {/*-----------------------*/}
                                  {cardb? (


                                     <div style={{width:'100%',height:'12vw',position:'absolute',top:'0vh',display:'flex',justifyContent:'center',alignItems:'center'}}>

                                                             <div style={{position:'absolute',width:'100%',top:0}}>
                                                              <img  src={hostloca+'Assets/flipcardbg3.png'} style={{width:'100%'}}/> 
                                                              </div>


                                                              <span className='textcard' style={{fontSize:'3vw',letterSpacing:'.4vw',top:'6vh',paddingLeft:'0vw',position:'absolute',color:'white'}}>FINAL SCORE!</span>  
                                                                <span className='textscored' style={{fontSize:'10vw',letterSpacing:'.5vw',top:'7.6vh',fontWeight:'bold',paddingLeft:'0vw',position:'absolute',color:'white'}}>{scoretonumbrt} </span>  
                                                                <span className='textnormal' style={{fontSize:'2.8vw',letterSpacing:'.5vw',top:'18vh',paddingLeft:'0vw',position:'absolute',fontWeight:400,color:'white'}}>您成功超越50%的玩家</span>  
                                                                <span className='textcard' style={{fontSize:'7vw',letterSpacing:'.4vw',top:'25vh',paddingLeft:'0vw',position:'absolute',color:'white'}}>Level Completed!</span>  
                                                               <span className='textnormal' style={{fontSize:'2.6vw',letterSpacing:'.5vw',top:'37vh',paddingLeft:'3vw',position:'absolute',fontWeight:400,color:'white'}}>小提示：   </span>  
                                                               <span className='textnormal' style={{fontSize:'2.6vw',letterSpacing:'.5vw',top:'40vh',paddingLeft:'0vw',position:'absolute',fontWeight:400,color:'white'}}>分数越高越机会解锁限定壁纸</span>  
                                    </div>


                                ):('')}      


                                  {cardc? (
                                     <div style={{width:'100%',height:'12vw',position:'absolute',top:'0vh',display:'flex',justifyContent:'center',alignItems:'center'}}>

                                                              <div style={{position:'absolute',width:'100%',top:0}}>
                                                              <img  src={hostloca+'Assets/flipcardbg3.png'} style={{width:'100%'}}/> 
                                                              </div>

                                                              <span className='textcard' style={{fontSize:'3vw',letterSpacing:'.4vw',top:'6vh',paddingLeft:'0vw',position:'absolute',color:'white'}}>FINAL SCORE!</span>  
                                                                <span className='textscored' style={{fontSize:'10vw',letterSpacing:'.5vw',top:'7.6vh',fontWeight:'bold',paddingLeft:'0vw',position:'absolute',color:'white'}}>{scoretonumbrt} </span>  
                                                                <span className='textnormal' style={{fontSize:'2.8vw',letterSpacing:'.5vw',top:'18vh',paddingLeft:'0vw',position:'absolute',fontWeight:400,color:'white'}}>步数用尽 收集未完成</span>  
                                                                <span className='textcard' style={{fontSize:'7vw',letterSpacing:'.4vw',top:'25vh',paddingLeft:'0vw',position:'absolute',color:'white'}}>Try Again!</span> 
                     
                                                          <span className='textnormal' style={{fontSize:'2.6vw',letterSpacing:'.5vw',top:'37vh',paddingLeft:'3vw',position:'absolute',fontWeight:400,color:'white'}}>小提示：   </span>  
                                                          <span className='textnormal' style={{fontSize:'2.6vw',letterSpacing:'.5vw',top:'40vh',paddingLeft:'0vw',position:'absolute',fontWeight:400,color:'white'}}>成功通关即可解锁限定壁纸</span>  
                             
                                    </div>
                                ):('')}        

        </animated.div>
        <animated.div style={{
          ...riseProps,
          width: '70vw',
          height: '300px',
          borderRadius: '0px',
          position: 'absolute',
          willChange: 'transform, opacity',
          backfaceVisibility: 'hidden',
          transform: transform.interpolate(t => `${t} rotateY(180deg)`),
          opacity,
        }}>
                    <div style={{position:'absolute',width:'100%'}}>
                    <img  src={hostloca+'Assets/flipcardb.png'} style={{width:'100%'}}/> 


                    </div>

                    <div style={{width:'100%',height:'12vw',position:'absolute',top:'6vh',display:'flex',justifyContent:'center',alignItems:'center'}}>
                    <div style={{position:'absolute',width:'96%',top:'-4vh'}}>
                    <img  src={cardurl} style={{width:'100%'}}/> 

                    </div>
                    </div>
        </animated.div>
      </div>
    );
  }





function Tipslayer(props){

  const [tips1,settips1]=useState(['flex',0])
  const [tips2,settips2]=useState(['none',0])
  const [tips3,settips3]=useState(['none',0])

  const [tipsbox,settipsbox]=useState(true)
  
  const state = useStore()


  function keepplay(){
   if(showedtips==1){
        settips1(['flex',0])

        setTimeout(() => {
          settips1(['none',0])
          ontips=false
        }, 500);

   }else if(showedtips==2){
    settips2(['flex',0])

    setTimeout(() => {
      settips2(['none',0])
      ontips=false
    }, 500);

  }else if(showedtips==3){
    settips3(['flex',0])

    setTimeout(() => {
      settips3(['none',0])
      ontips=false
    }, 500);

}
    

      console.log('skip tips')

  }


  useEffect(()=>{

    if(state.endgame==1)settipsbox(false)
  },[state.endgame])


  useEffect(()=>{
   
    if(state.loaded && showtipscount[0]!=1){
      if(ontips==false){
        showedtips=1
        showtipscount[0]=1
        ontips=true
        setTimeout(() => {
          settips1(['flex',1])
        }, 4000);
        
      }else{

      }
      
    }

  },[state.loaded])


  useEffect(()=>{

    if(state.loaded  && state.endgame==0  && showtipscount[1]!=1){
      if(ontips==false){
        showedtips=2
        showtipscount[1]=1
        settips2(['flex',0])
        ontips=true
        setTimeout(() => {
          settips2(['flex',1])
        }, 500);
        
      }else{
        state.effecta=false  //当前有弹窗并行，释放判断
      }
      
    }

  },[state.effectc])


  useEffect(()=>{

      if(state.loaded && state.endgame==0  && showtipscount[2]!=1){
        if(ontips==false){
          ontips=true
          showtipscount[2]=1
          showedtips=3
          settips3(['flex',0])
          setTimeout(() => {
            settips3(['flex',1])
          }, 500);
          
        }else{
          state.effecta=false //当前有弹窗并行，释放判断
        }
        
      }

     

  },[state.effecta])

     
    return <div style={{width:'100vw',height:'100vh',position:'absolute',left:0,top:0,pointerEvents:'none'}}>
      {tipsbox? (
        <div>
                              
                               <div style={{width:'100vw',height:'100vh',position:'absolute',left:0,top:0,opacity:tips1[1],display:tips1[0],transition:`all .6s`,justifyContent:'center',alignItems:'center',pointerEvents:'auto'}}>
                              
                                             <div style={{width:'100vw',height:'100vh',position:'absolute',left:0,top:0,backgroundColor:'black',opacity:.8}}>
                                            </div>
                                            <div style={{position:'absolute',width:'30%',top:'20vh'}}>
                                            <img  src={hostloca+'Assets/tips.png'} style={{width:'100%'}}/> 
                                            </div>
                                            <div style={{position:'absolute',width:'60%',top:'25vh',opacity:tips1[1]}}>
                                            <img  src={hostloca+'Assets/tips1.gif'} style={{width:'100%'}}/> 
                                            </div>

                                             {/*  
                                            <span className='textnormal' style={{fontSize:'2.6vw',letterSpacing:'.5vw',top:'53vh',paddingLeft:'0vw',position:'absolute',fontWeight:400,color:'white',width:'60VW',wordBreak:'break-word',lineHeight:'1.4vh',textAlign:'center'}}>
                                             将相同的3个以上数字连成⼀列即可消除<p/>
                                             在步数⽤尽前集满指定数字即可过关</span>
                                             */} 

                                            <div style={{position:'absolute',width:'70%',top:'50vh'}}>
                                            <img  src={hostloca+'Assets/tips1line.png'} style={{width:'100%'}}/> 
                                            </div>

                                             <div onClick={()=>keepplay()}  style={{width:'32vw',height:'9vw',borderRadius:'8vw',color:'white',position:'absolute',left:'35%',top:'75vh',display:'flex',justifyContent:'center',alignItems:'center',fontSize:'3vw',letterSpacing:'.4vw', border: '1px solid',zIndex:420,transition:`all .2s`,opacity:1,fontWeight:600}}>继续</div>
 

                                </div>



                                 
                               <div style={{width:'100vw',height:'100vh',position:'absolute',left:0,top:0,opacity:tips2[1],display:tips2[0],transition:`all .6s`,justifyContent:'center',alignItems:'center',pointerEvents:'auto'}}>
                              
                                        <div style={{width:'100vw',height:'100vh',position:'absolute',left:0,top:0,backgroundColor:'black',opacity:.8}}>
                                        </div>
                                        <div style={{position:'absolute',width:'30%',top:'20vh'}}>
                                        <img  src={hostloca+'Assets/tips.png'} style={{width:'100%'}}/> 
                                        </div>
                                        <div style={{position:'absolute',width:'60%',top:'25vh',opacity:tips2[1]}}>
                                        <img  src={hostloca+'Assets/tips2.gif'} style={{width:'100%'}}/> 
                                        </div>

                                      

                                        <div style={{position:'absolute',width:'70%',top:'50vh'}}>
                                        <img  src={hostloca+'Assets/tipssline2.png'} style={{width:'100%'}}/> 
                                        </div>

                                          <div onClick={()=>keepplay()}  style={{width:'32vw',height:'9vw',borderRadius:'8vw',color:'white',position:'absolute',left:'35%',top:'75vh',display:'flex',justifyContent:'center',alignItems:'center',fontSize:'3vw',letterSpacing:'.4vw', border: '1px solid',zIndex:420,transition:`all .2s`,opacity:1,fontWeight:600}}>继续</div>
 

                             </div>


                             <div style={{width:'100vw',height:'100vh',position:'absolute',left:0,top:0,opacity:tips3[1],display:tips3[0],transition:`all .6s`,justifyContent:'center',alignItems:'center',pointerEvents:'auto'}}>
                              
                              <div style={{width:'100vw',height:'100vh',position:'absolute',left:0,top:0,backgroundColor:'black',opacity:.8}}>
                                </div>
                                <div style={{position:'absolute',width:'30%',top:'20vh'}}>
                                <img  src={hostloca+'Assets/tips.png'} style={{width:'100%'}}/> 
                                </div>
                                <div style={{position:'absolute',width:'60%',top:'25vh',opacity:tips3[1]}}>
                                <img  src={hostloca+'Assets/tips3.gif'} style={{width:'100%'}}/> 
                                </div>

                              

                                <div style={{position:'absolute',width:'70%',top:'50vh'}}>
                                <img  src={hostloca+'Assets/tips3line.png'} style={{width:'100%'}}/> 
                                </div>

                                  <div onClick={()=>keepplay()}  style={{width:'32vw',height:'9vw',borderRadius:'8vw',color:'white',position:'absolute',left:'35%',top:'75vh',display:'flex',justifyContent:'center',alignItems:'center',fontSize:'3vw',letterSpacing:'.4vw', border: '1px solid',zIndex:420,transition:`all .2s`,opacity:1,fontWeight:600}}>继续</div>


                           </div>


                      </div>

                                            ):('')}
          </div>





}


export default function Uilayer(props) {

   const state = useStore()
    const [score,setscore]=useState([0,0,0,60,0,20])
    const [numleft,setnumleft]=useState(2.6)
    const [showend,setshowend]=useState(false)
    const [endcardalpha,setendcardalpha]=useState(0)
    const [scorboardalopa,setscorboardalopa]=useState(0)

    const [scorestate,setscorestate]=useState('a')
    const [scorerecord,setscorerecord]=useState(0)

    const [nextplay,setnextplay]=useState('none')
    const [replay,setreplay]=useState('none')

    const [dotmark,setdotmark]=useState([])
    const [toggle, setToggle] =useState(false);
    const [toggletime, settoggletime] =useState(1000);
    const [playsound, setplaysound] =useState(false);
    const [playsound2, setplaysound2] =useState(false);
    const [playsound3, setplaysound3] =useState(false);   

    const [gamefinish, setgamefinish] =useState(false);   
    const [startalpha, setstartalpha] = useState(1);
    const [btnscale, setbtnscale] = useState([1,1]);
    const [collectfonts, setcollectfonts] = useState(['4.6vw','2vw']);


    const [coloectlable,setcoloectlable]=useState(['46vh',0,.3])
    
    const [showtips,setshowtips]=useState(0)
    
    let navigate =useNavigate();
    let location =useLocation()
    
         /*
        const sound = new Howl({
          
          src: [hostloca+'media/sound3.mp3'],
          volume: 1.0,  // 设置音量，范围 0.0 到 1.0
          onend: () => {
          // console.log('Sound effect has finished playing.');
          }
          
        });

        const soundg1 = new Howl({
          
          src: [hostloca+'media/sound1.mp3'],
          volume: 1.0,  // 设置音量，范围 0.0 到 1.0
          onend: () => {
            //console.log('Sound effect has finished playing.');
          }
           
        });

        const soundg2 = new Howl({
          
          src: [hostloca+'media/sound2.mp3'],
          volume: 1.0,  // 设置音量，范围 0.0 到 1.0
          onend: () => {
            //console.log('Sound effect has finished playing.');
          }
          
        });

        const soundg4 = new Howl({
          
          src: [hostloca+'media/ending.mp3'],
          volume: 1.0,  // 设置音量，范围 0.0 到 1.0
          onend: () => {
            //console.log('Sound effect has finished playing.');
          }
          
        });

        const soundbg = new Howl({
           
          src: [hostloca+'media/bg.mp3'],
          volume: .1,  // 设置音量，范围 0.0 到 1.0
          loop: true ,
            onend: () => {
              //console.log('Sound effect has finished playing.');
            }
            
        });

        const soundg5 = new Howl({
          
          src: [hostloca+'media/sound5.mp3'],
          volume: .1,  // 设置音量，范围 0.0 到 1.0
          loop: false ,
            onend: () => {
              //console.log('Sound effect has finished playing.');
            }
            
        });

        const soundg6 = new Howl({
          
          src: [hostloca+'media/sound6.mp3'],
          volume: .1,  // 设置音量，范围 0.0 到 1.0
          loop: false ,
            onend: () => {
              //console.log('Sound effect has finished playing.');
            }
             
        });

        const soundbg_32 = new Howl({
          
          src: [hostloca+'media/bgm3.3.mp3'],
          volume: .1,  // 设置音量，范围 0.0 到 1.0
          loop: true ,
            onend: () => {
              //console.log('Sound effect has finished playing.');
            }
            
        });

        const boom_sound = new Howl({
          
          src: [hostloca+'media/bgboom.mp3'],
          volume: 1,  // 设置音量，范围 0.0 到 1.0
            onend: () => {
              //console.log('Sound effect has finished playing.');
            }
             
        });

        const bonus_sound = new Howl({
          
          src: [hostloca+'media/Bonus.mp3'],
          volume: 1,  // 设置音量，范围 0.0 到 1.0
            onend: () => {
              //console.log('Sound effect has finished playing.');
            }
             
        });

        */

        /**
         * audio soundeffect 
         */
        //======================================================================================
        
        const bgaudioRef = useRef(new Audio(hostloca+'media/bg.mp3'));
        const audioRef = useRef(new Audio(hostloca+'media/allsound.mp3'));
        const audioRefb = useRef(new Audio(hostloca+'media/allsound.mp3'));
        const [playSegment, setPlaySegment] = useState({ start: 0, end: 0 });
        const [playSegmentb, setPlaySegmentb] = useState({ start: 0, end: 0 });

        const [soundbtn, setsoundbtn] = useState([1,0]);

        let canplaysound=true


        const soundbgm=()=>{
          let bgaudio= bgaudioRef.current
          bgaudio.volume = 0.1;
          bgaudio.autoplay = true;
          bgaudio.loop = true;
          bgaudio.play();
          }

       

          useEffect(()=>{
              const bgaudio = bgaudioRef.current;
              if (!bgaudio) return;

              if(soundbtn[0]!=1){
                bgaudio.pause();
              }else{
                bgaudio.play();
              }
            

              const handlePlay = () => {
                bgsound=true
                console.log("Audio is playing");
              };

              bgaudio.addEventListener('play', handlePlay);
              return () => {
                bgaudio.removeEventListener('play', handlePlay);
             
          };

          },[soundbtn])


        useEffect(() => {
         
          const audio = audioRef.current;
  
          const checkTime = () => {
              if (audio.currentTime >= playSegment.end) {
                  audio.pause();
                  // 可以根据需求设置是否重置时间
                  // audio.currentTime = playSegment.start;
              }
          };
  
          if (playSegment.start !== playSegment.end) {
              audio.currentTime = playSegment.start;
              audio.play();
              audio.addEventListener('timeupdate', checkTime);
          }
  
          return () => {
              audio.removeEventListener('timeupdate', checkTime);
          };
        }, [playSegment]);



          useEffect(() => {
            const audiob = audioRefb.current;
    
            const checkTimeb = () => {
                if (audiob.currentTime >= playSegmentb.end) {
                  audiob.pause();
                    // 可以根据需求设置是否重置时间
                    // audio.currentTime = playSegment.start;
                }
            };
    
            if (playSegmentb.start !== playSegmentb.end) {
              audiob.currentTime = playSegment.start;
              audiob.play();
              audiob.addEventListener('timeupdate', checkTimeb);
            }
    
            return () => {
              audiob.removeEventListener('timeupdate', checkTimeb);
            };
          }, [playSegmentb]);


 



       const playAudioSegment = (start, end) => {
        
        if(soundbtn[0]==1){
         setPlaySegment({ start, end });
        }

       };

       const playAudioSegmentb = (start, end) => {
        if(soundbtn[0]==1){
          setPlaySegment({ start, end });
        }
        
        
       };
       

       
       const soundtouch = () => {
        playAudioSegment(0,1.7);
       };

       const soundscore = () => {
        playAudioSegment(2,3.7);
       };

       const sounddelete = () => {
        playAudioSegment(4,5.7);
       };

       const soundeffectc = () => {
        playAudioSegmentb(6.2,7.7);
       };

       const soundbonus = () => {
        playAudioSegmentb(8,9.7);
       };

       const soundboom = () => {
        playAudioSegmentb(10,11.7);
       };

       const soundendding = () => {
        playAudioSegmentb(12,14.7);
       };

       const soundenddingb = () => {
        playAudioSegmentb(15,16.7);
       };


         
           
        //=======================================================================================

        useEffect(() => {
          const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
              console.log('web-view In stage');
              if(soundstate=='on'){
                setsoundbtn([1,0])
              }
            } else if (document.visibilityState === 'hidden') {
              console.log('web-view  out of stage');
               
                  setsoundbtn([0,1])
                
            }
          };
      
          document.addEventListener('visibilitychange', handleVisibilityChange);
      
          // 清理函数
          return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
          };
        }, []); 





        //=======================================================================================



    useEffect(()=>{


        if(!state.loaded)return
        
        if(!showcollect){
          showcollect=true
          setcoloectlable(['46vh',1,0.2])

        }

        let endgame=state.endgame
      
        if(state.startgame==1 && scorboardalopa==0){

            setscorboardalopa(1)    
            
            setTimeout(() => {
              setcoloectlable(['91vh',1,1.2])
         
            }, 2000);
            
        }
        
       
       
        if(endgame==1 && scorboardalopa==1){


            if(gamefinish==false){

                setgamefinish(true)

                setscorboardalopa(0)
                setcoloectlable(['97vh',0,1])
                setshowend(true)
                setTimeout(() => {
                    setendcardalpha(1)
 
                }, 300);

      
      
           //成绩判定  3 type score
            if(state.collect<=0){

                if(scorerecord==0){
                    setscorestate('a')
                    userscoretype='a'
                }else  if(scorerecord==1){
                    setscorestate('b')
                    userscoretype='b'
                }
            
                setTimeout(() => {
                    setnextplay('flex')
                    setreplay('none')
                }, 4000);
              
                // if(usehowler)soundg4.play()
                 soundendding()

            }else{
                 setscorestate('c')  
                 userscoretype='c'
                 setnextplay('none')
                 setreplay('flex')

                // if(usehowler)soundg6.play()
                 soundenddingb()
            }

          }
        
       

       }else{
   
            
            let sc=state.count

            
            
                if(sc<10){
                    sc='00'+sc
                }else if(sc>=10 && sc <100){
                    sc='0'+sc
                }
            
            let str = sc.toString();  // 将数字转换为字符串
                let chars = str.split('');  
                let tagetnum=state.num

                //特殊处理0
                if(state.num==23){
                  tagetnum=0
                }

                chars.push(state.step)
                chars.push(tagetnum)
                chars.push(state.collect)
                console.log('score : '+sc)
                setscore(chars)
               
              

                if(tagetnum>=10){
                  setcollectfonts(['4vw','0vw'])
                }else{
                  setcollectfonts(['4.6vw','0vw'])
                }

                if(chars[0]==1 && numleft!=3.1){
                    setnumleft(3.1)

                }else if(chars[0]!=1  && numleft==3.1){
                    setnumleft(2.6)
                }

                if(sc>0){

                 // if(usehowler)soundg2.play();
                  
                  soundscore()
               
                }

               

               
               if(state.mark.length>0){
                    setdotmark(state.mark)
                  //  let mk=state.mark[state.mark.length-1][0]
                   // settoggletime((10-mk)*100)
                    setToggle(true)
                 
                   // if(usehowler)soundg1.play();
                    sounddelete()
                   
               }
                
 
            
            }

    

    }, [state.count,state.endgame,state.startgame,state.loaded])


    useEffect(()=>{
      //滑动小球
     if(state.touch){
      
      //if(usehowler)sound.play();
      soundtouch()
     }
        if(bgsound==false ){
          
         
            //if(usehowler)soundbg.play()
             soundbgm()
            
     
        }
  
      
    }, [state.touch])


    useEffect(()=>{
     
      if(bgsound==false ){
 
          //if(usehowler)soundbg.play()
           soundbgm()
         
     
      }

      game_state=state.gamestate
  
      
    }, [state.gamestate])



    useEffect(()=>{
     
         if(  state.boom==true){
        //  if(usehowler)boom_sound.play()
         soundboom()
     
          state.boom=false

          
         }
      
    }, [state.boom])

    useEffect(()=>{
     
      if(  state.bonus==true){
       // if(usehowler)bonus_sound.play()
       soundbonus()
  
       state.bonus=false
 
      }
   
   }, [state.bonus])
    

    useEffect(()=>{
     
      if(state.effectc){
       // if(usehowler)soundg5.play();
        soundeffectc()
        state.effectc=false

      }
        
      }, [state.effectc])

    const collectprops = useSpring({
        to: { transform: `scale(${toggle ? 1.5 : 1})` },
        from: { transform: 'scale(1)' },
        reset: true,
        reverse: toggle,
        delay:0,
        onRest: () => {
            setToggle(!toggle)
        },
      });


      



     function backhome(){
      //  navigate('/',{state:{id:0,nick:''}})
      window.location.replace('/')
     }


    function replaygame(){

      setdata=false
        setshowend(false)

        setTimeout(() => {
            setendcardalpha(0)

            setscorboardalopa(1)
            setcoloectlable(['91vh',1,1])
            setgamefinish(false)

        }, 1000);

        setbtnscale([1,1,.5])
        props.callback()

    }


    function viewmycard(){
      setshowend(false)
          setbtnscale([.5,1,1])

          if(state.gamestate==1){
            window.location.replace('/mycard?s=1')
           }else if(state.gamestate==2){
            window.location.replace('/mycard?s=2')
           }else if(state.gamestate==3){
            window.location.replace('/mycard?s=3')
           }

    }

    function playnext(){
         setdata=false
         setshowend(false)
         setbtnscale([1,.5,1])

         if(state.gamestate==1){
          window.location.replace('/g2')
         }else if(state.gamestate==2){
          window.location.replace('/g3')
         }else if(state.gamestate==3){
          window.location.replace('/g1')
         }





    }


    function soundbtnclick(){

      if(soundbtn[0]==1){
        //off sound
           setsoundbtn([0,1])
           canplaysound=false
           soundstate='off'
      }else{
        // on sound
           setsoundbtn([1,0])
           canplaysound=true
           soundstate='on'
      }


    }



    return  <div>
       
                <div    style={{width:'100vw',height:'100vh',color:'white',position:'absolute',left:0,top:0,display:'flex',justifyContent:'center',alignItems:'center',pointerEvents:'none',opacity:scorboardalopa,transition:`all .5s`}}>         


                           {/*score   */}   
                        <div style={{width:'28vw',height:'12vw',position:'absolute',top:'13vh'}}>

                            <img  src={hostloca+'Assets/scoreboard.png'} style={{width:'100%'}}/> 
                                  
                        </div>

                        <div style={{width:'28vw',height:'12vw',position:'absolute',top:'13vh',display:'flex',justifyContent:'center',alignItems:'center'}}>
                               <span className='textscore' style={{fontSize:'5.4vw',letterSpacing:'6.1vw',paddingTop:'6.4vw',paddingLeft:'0vw',position:'absolute',left:numleft+'vw'}}>{score[0]}</span>
                               <span className='textscore' style={{fontSize:'5.4vw',letterSpacing:'6.1vw',paddingTop:'6.4vw',paddingLeft:'6vw',position:'absolute'}}>{score[1]}</span>  
                               <span className='textscore' style={{fontSize:'5.4vw',letterSpacing:'6.1vw',paddingTop:'6.4vw',paddingLeft:'0vw',position:'absolute',left:'22vw'}}>{score[2]}</span> 
                        </div>


                                  {/*step   */}  
                       
                                     <div style={{width:'50vw',height:'12vw',position:'absolute',top:'4vh'}}>

                                    <img  src={hostloca+'Assets/step.png'} style={{width:'100%'}}/> 
                                        
                                    </div>


                                                
                                    <div style={{width:'28vw',height:'12vw',position:'absolute',top:'6.5vh',display:'flex',justifyContent:'center',alignItems:'center'}}>
                                        
                                        <span className='textstep' style={{fontSize:'6vw',letterSpacing:'1vw',paddingTop:'0',paddingLeft:'1.5vw',position:'absolute'}}>{score[3]}</span>  
                                        
                                    </div>
 
 
                </div>



                


                            {/*collection   */}    

                            <div style={{position:'absolute',left:'36vw',top:coloectlable[0],opacity:coloectlable[1],transition:`all ${coloectlable[2]}s`,pointerEvents:'none'}}>

                                        <div style={{width:'30vw',height:'12vw',position:'absolute',top:'0vh'}}>

                                        <img  src={hostloca+'Assets/collection.png'} style={{width:'100%'}}/> 
                                          
                                        </div>

                                          <div style={{width:'9vw',height:'9vw',display:'flex',alignItems:'center',justifyContent:'center',position:'absolute',left:'9.5vw',top:'-1vh'}}>
                                            <div className='textscore' style={{fontSize:'3.5vw',textAlign:'center',border: '2px solid #ffffff',borderRadius:'50%',width:'60%',height:'60%',color:'white',display:'flex',justifyContent:'center',alignItems:'center'}}>
                                              <div style={{marginTop:'.2vh'}}>
                                              {score[4]}
                                              </div>
                                            </div>

                                          </div>




                                          <animated.div style={{...collectprops,width:'28vw',height:'12vw',position:'absolute',top:'-1.8vh',display:'flex',justifyContent:'center',alignItems:'center',color:'white'}}>

                                          <span className='textcollect' style={{fontSize:'4vw',letterSpacing:'0.2vw',paddingTop:'.5vw',paddingLeft:'19vw',position:'absolute'}}>{score[5]}</span>  
                                          <span className='textcollect' style={{fontSize:'4vw',letterSpacing:'0.4vtruew',paddingTop:'0vw',paddingLeft:'11vw',position:'absolute'}}>x</span>  

                                          </animated.div>
                            </div> 

              

                

                {showend? (
                 <div style={{opacity:endcardalpha,transition:`all 1s`}}>
                  <div  style={{width:'100vw',height:'100vh',position:'absolute',left:'0',top:'0',display:'flex',justifyContent:'center',alignItems:'center',zIndex:400}}>
                   
                 <Confetti scoretype={scorestate} />
                 </div>

                <FlipCard show={showend}  score={score[0]+score[1]+score[2]} scorestate={scorestate} targetnum={score[4]}/>

                
                <div onClick={()=>viewmycard()}  style={{width:'32vw',height:'9vw',borderRadius:'8vw',color:'white',position:'absolute',left:'15%',top:'80vh',display:nextplay,justifyContent:'center',alignItems:'center',fontSize:'3vw',letterSpacing:'.4vw',border: '1px solid',zIndex:420,transition:`all .2s`,opacity:btnscale[0],fontWeight:600}}>查看收集进度</div>


                <div onClick={()=>playnext()} style={{width:'32vw',height:'9vw',borderRadius:'8vw',color:'white',position:'absolute',left:'53%',top:'80vh',display:nextplay,justifyContent:'center',alignItems:'center',fontSize:'3vw',letterSpacing:'.4vw', border: '1px solid',zIndex:420,transition:`all .2s`,opacity:btnscale[1],fontWeight:600}}>挑战下一关</div>

                <div onClick={()=>replaygame()}  style={{width:'32vw',height:'9vw',borderRadius:'8vw',color:'white',position:'absolute',left:'35%',top:'80vh',display:replay,justifyContent:'center',alignItems:'center',fontSize:'3vw',letterSpacing:'.4vw', border: '1px solid',zIndex:420,transition:`all .2s`,opacity:btnscale[2],fontWeight:600}}>重新挑战</div>



                </div>
                ):('')}
                {/*
             {playsound? (
              <ReactHowler src={hostloca+'media/sound2.mp3'} playing={playsound} />

             ):('')}

                {playsound2? (
              <ReactHowler src={hostloca+'media/sound1.mp3'} playing={playsound2} />

             ):('')}

             
            {playsound3? (
              <ReactHowler src={hostloca+'media/sound3.mp3'} playing={playsound3} />

             ):('')} */}

              <DotMatrix mark={dotmark} />


            



              <div onClick={()=>backhome()} className='btnnohightline'  style={{width:'7vw',height:'7vw',position:'absolute',top:'3vh',left:'5vw',opacity:scorboardalopa}}>

              <img  src={hostloca+'Assets/back.png'} style={{width:'100%'}}/> 
                  
              </div>


              <div onClick={()=>soundbtnclick()} className='btnnohightline'  style={{width:'8vw',height:'3vw',position:'absolute',top:'3vh',right:'4vw',opacity:scorboardalopa}}>

              <img  src={hostloca+'Assets/soundbtn.png'} style={{position:'absolute',width:'100%',opacity:soundbtn[0]}}/> 
              <img  src={hostloca+'Assets/soundbtnoff.png'} style={{position:'absolute',width:'100%',opacity:soundbtn[1]}}/> 
              
                  
              </div>

 
             <Tipslayer tips={showtips}/>

         </div>

 

}